import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { DxDataGridModule } from 'devextreme-angular';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { AuthModule } from '../auth/auth.module';
import { PipesModule } from '../common/pipes/pipes.module';
import { ActivitiesModule } from '../components/activities/activities.module';
import { FormsConstructorModule } from '../forms/forms-constructor.module';
import { SharedModule } from '../shared.module';
import { ViewsModule } from '../views/views.module';
import { DialogActivitiesComponent } from './dialogs/dialog-activities/dialog-activities.component';
import { DialogAdminDeclineRequestComponent } from './dialogs/dialog-admin-decline-request/dialog-admin-decline-request.component';
import { DialogConfirmComponent } from './dialogs/dialog-confirm/dialog-confirm.component';
import { DialogConversationTitleEditComponent } from './dialogs/dialog-conversation-title-edit/dialog-conversation-title-edit.component';
import { DialogCreateCategoryComponent } from './dialogs/dialog-create-category/dialog-create-category.component';
import { DialogCropComponent } from './dialogs/dialog-crop/dialog-crop.component';
import { DialogDeactivateAccountComponent } from './dialogs/dialog-deactivate-account/dialog-deactivate-account.component';
import { DialogDefaultComponent } from './dialogs/dialog-default/dialog-default.component';
import { DialogIndividualRoleSelectComponent } from './dialogs/dialog-individual-role-select/dialog-individual-role-select.component';
import { DialogInviteAdminComponent } from './dialogs/dialog-invite-admin/dialog-invite-admin.component';
import { DialogMessageComponent } from './dialogs/dialog-message/dialog-message.component';
import { DialogSendReactivationPetitionComponent } from './dialogs/dialog-send-reactivation-request/dialog-send-reactivation-request.component';
import { DialogUpdateCategoryComponent } from './dialogs/dialog-update-category/dialog-update-category.component';
import { DialogUserInfoComponent } from './dialogs/dialog-user-info/dialog-user-info.component';
import { DialogsDirective } from './dialogs/dialogs.directive';
import { InformationDialogComponent } from './dialogs/informational-dialog/information-dialog.component';
import { NotificationContextAttributesService } from './notifications-context-attributes.service';
import { NotificationsComponent } from './notifications.component';

@NgModule({
  imports: [
    ActivitiesModule,
    SharedModule,
    ViewsModule,
    AuthModule,
    DxDataGridModule,
    AngularMultiSelectModule,
    PipesModule,
    ImageCropperComponent,
    FormsConstructorModule,
  ],
  declarations: [
    NotificationsComponent,
    DialogsDirective,
    DialogDefaultComponent,
    DialogMessageComponent,
    DialogIndividualRoleSelectComponent,
    DialogActivitiesComponent,
    DialogCropComponent,
    DialogDeactivateAccountComponent,
    DialogCreateCategoryComponent,
    DialogUpdateCategoryComponent,
    DialogSendReactivationPetitionComponent,
    DialogAdminDeclineRequestComponent,
    DialogConfirmComponent,
    DialogUserInfoComponent,
    DialogConversationTitleEditComponent,
    DialogInviteAdminComponent,
    InformationDialogComponent,
  ],
  exports: [NotificationsComponent],
  providers: [NgbActiveModal],
})
export class NotificationsModule {
  public static forRoot(): ModuleWithProviders<NotificationsModule> {
    return {
      ngModule: NotificationsModule,
      providers: [NotificationContextAttributesService],
    };
  }
}
